import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { cloneDeep } from 'lodash-es';
import { ApiService } from '../../../../../core/services/api/api.service';
import { ToastService } from '../../../../../core/services/toast/toast.service';
import { Course } from '../../../../../models/interfaces/course.interface';
import { EnfafModalComponent } from '../../../../../components/enfaf-modal/enfaf-modal.component';

@Component({
  selector: 'app-modal-student-courses',
  imports: [MatDialogModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule, MatTooltipModule, EnfafModalComponent],
  templateUrl: './modal-student-courses.component.html',
  styleUrl: './modal-student-courses.component.scss'
})
export class ModalStudentCoursesComponent implements OnInit {
  studentId!: string;
  fullname!: string;
  courses: Array<Course> = [];
  isDownloadingProgress = false;
  someCourseHasProgress = false;
  downloadingDiplomaCourseId: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalStudentCoursesComponent>,
    private api: ApiService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    this.studentId = receivedData?.studentId;
    this.fullname = receivedData?.fullname;
    this.courses = receivedData?.courses;

    if (!this.studentId || !this.fullname) {
      this.closeModal();
    }

    const courseProgress = this.courses.find((course) => course.lastCompletedSection && course.lastCompletedModule && course.lastCompletedClass);
    if (courseProgress) {
      this.someCourseHasProgress = true;
    }
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  async downloadStudentCoursesProgress(): Promise<void> {
    try {
      this.isDownloadingProgress = true;
      const result = await this.api.downloadStudentCoursesProgress(this.studentId);
      if (!result) {
        this.toast.presentErrorToast('No hay progreso para descargar o hubo un error descargando el archivo');
      }
      this.isDownloadingProgress = false;
    } catch (error: any) {
      this.isDownloadingProgress = false;
      this.toast.presentErrorToast('Hubo un error descargando archivo');
    }
  }

  exportCourseEnrollmentOrder(courseId: string): void {
    this.api.exportCourseStudentsEnrollmentOrders(courseId, [this.studentId]);
  }

  async downloadCourseDiploma(courseId: string): Promise<void> {
    try {
      this.downloadingDiplomaCourseId = courseId;
      const success = await this.api.downloadCourseStudentDiploma({ courseId, userId: this.studentId });
      if (!success) {
        this.toast.presentErrorToast('No se encontró el diploma o hubo un error descargándolo');
      }
    } catch (error: any) {
      this.toast.presentErrorToast(error?.message || 'Hubo un error descargando el diploma');
    } finally {
      this.downloadingDiplomaCourseId = null;
    }
  }
}
